import { DatePicker, Input } from "antd";
import "antd/dist/antd.css";
import "moment/min/locales";
import React, { useContext } from "react";
import { FormCheck, FormControl } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import TagsInput from "react-tagsinput";
import { labels } from "../../../localization/labels";
import LocalizationUtil from "../../../localization/LocalizationUtil";
import CommonUtil from "../../../utils/CommonUtil";
import { constants } from "../../../utils/Constants";
import SecurityUtil from "../../../utils/SecurityUtils";
import { AppContext } from "../../domain/App/AppContext";

const { RangePicker } = DatePicker;

const { Search } = Input;

const DATE_FORMAT = constants.DATE_FORMAT;

const SubmitControl = props => {
  const {
    onChange,
    type,
    validationRule,
    value,
    controlId,
    processes,
    partyId
  } = props;
  const validate = validationRule?.validate;
  const isRequired = validationRule?.required;
  const partyHasAnyOfProcessesOrSameParty = SecurityUtil.partyHasAnyOfProcessesOrSameParty(
    processes,
    partyId
  );

  let isValid;
  let isInvalid;

  if (props.valid !== undefined) {
    if (props.valid) {
      isValid = true;
    } else {
      isInvalid = true;
    }
  }

  if (validate) {
    if (validate(props.value)) {
      isValid = true;
    } else {
      isInvalid = true;
    }
  }

  const disableable =
    props.disableable === undefined ? true : props.disableable;

  const inProgress = useContext(AppContext).promiseInProgress;
  const afInput = useContext(AppContext).afInput;

  const autoFocus = props.autoFocus && !isMobile;

  if (type === "date") {
    const error = (isRequired && !value) || isInvalid;

    return (
      <DatePicker
        className={error ? "error" : "valid"}
        disabled={
          disableable &&
          (props.disabled || inProgress || !partyHasAnyOfProcessesOrSameParty)
        }
        placeholder={props.placeholder}
        format={constants.MOMENT_DATETIME_FORMAT}
        locale={LocalizationUtil.getPartyLocaleObject()}
        value={value ? LocalizationUtil.localDateTime(value, false) : undefined}
        onChange={e =>
          onChange &&
          onChange({
            target: { id: controlId, value: e && e.format(DATE_FORMAT) }
          })
        }
      />
    );
  } else if (type === "dateRange") {
    const error = (isRequired && !(value && value.dateFrom)) || isInvalid;

    return (
      <RangePicker
        allowEmpty={[false, true]}
        separator="~"
        className={error ? "error" : "valid"}
        disabled={
          disableable &&
          (props.disabled ||
            inProgress ||
            !partyHasAnyOfProcessesOrSameParty ||
            props.readOnly)
        }
        placeholder={props.placeholder}
        format={constants.MOMENT_DATE_FORMAT}
        locale={LocalizationUtil.getPartyLocaleObject()}
        value={[
          value?.dateFrom
            ? LocalizationUtil.localDate(value?.dateFrom, false)
            : undefined,
          value?.dateTo
            ? LocalizationUtil.localDate(value.dateTo, false)
            : undefined
        ]}
        onChange={e => {
          const dateFrom = e?.[0]?.format(DATE_FORMAT);
          const dateTo = e?.[1]?.format(DATE_FORMAT);
          onChange &&
            onChange({
              target: {
                id: controlId,
                value: { dateFrom: dateFrom, dateTo: dateTo }
              }
            });
        }}
      />
    );
  } else if (type === "search") {
    var searchClass = "search-class";
    searchClass += props.size === "xs" ? " search-class-xs" : "";
    return (
      <Search
        disabled={disableable && (props.disabled || inProgress)}
        className={searchClass}
        placeholder={props.placeholder}
        onChange={props.onChange}
        value={value}
        style={props.style}
        size={props.size}
        onSearch={props.onSearch}
        enterButton={props.enterButton}
        autoFocus={autoFocus}
        readOnly={props.readOnly}
        ref={autoFocus ? afInput : undefined}
        onClick={props.onClick}
      />
    );
  } else if (type === "tags") {
    const disabled =
      disableable &&
      (props.disabled || inProgress || !partyHasAnyOfProcessesOrSameParty);

    const inputProps = {
      placeholder: disabled ? "" : labels.addTag
    };

    return (
      <TagsInput
        className={
          disabled
            ? "react-tagsinput react-tagsinput-disabled"
            : "react-tagsinput"
        }
        onlyUnique
        addOnBlur
        addOnPaste
        preventSubmit
        value={value}
        onChange={onChange}
        disabled={disabled}
        inputProps={inputProps}
        renderTag={props.renderTag}
        renderLayout={props.renderLayout}
      />
    );
  } else if (type === "checkbox") {
    return (
      <FormCheck>
        <div className="d-flex align-items-center">
          <FormCheck.Input
            className="submit-checkbox"
            checked={CommonUtil.stringToBoolean(value)}
            onChange={e => {
              e.target.value = e.target.checked;
              e.target.id = controlId ? controlId : e.target.id;
              onChange(e);
            }}
            disabled={
              disableable &&
              (props.disabled ||
                inProgress ||
                !partyHasAnyOfProcessesOrSameParty)
            }
          />
          <FormCheck.Label>{props.title}</FormCheck.Label>
        </div>
      </FormCheck>
    );
  } else {
    return (
      <FormControl
        ref={autoFocus ? afInput : undefined}
        autoFocus={autoFocus}
        plaintext={props.plaintext}
        readOnly={props.readOnly}
        title={props.title}
        placeholder={props.placeholder}
        required={props.required || isRequired}
        type={props.type}
        value={props.value || ""}
        onChange={props.onChange}
        disabled={
          disableable &&
          (props.disabled || inProgress || !partyHasAnyOfProcessesOrSameParty)
        }
        isValid={isValid}
        isInvalid={isInvalid}
        as={props.as}
        rows={props.rows}
        maxLength={props.maxLength}
        onDoubleClick={props.onDoubleClick}
        size={props.size}
      />
    );
  }
};

SubmitControl.defaultProps = {
  disabled: false,
  required: false,
  valid: undefined
};

export default SubmitControl;
